import * as React from "react";
import { Link } from "react-router-dom";

import styles from "./Breadcrumb.module.scss";
import clsx from "clsx";

export interface BreadcrumbProps {
  links?: { title: string; to: string }[];
  currentTitle: string;
}

export const Breadcrumb = (props: BreadcrumbProps) => {
  return (
    <nav className={styles.wrapper}>
      <ol className="breadcrumb">
        {props.links?.map((link, index) => (
          <li key={index} className={clsx("breadcrumb-item", styles.item)}>
            <Link to={link.to} className={styles.link}>
              {link.title}
            </Link>
          </li>
        ))}
        <li className={clsx("breadcrumb-item active", styles.item)}>
          {props.currentTitle}
        </li>
      </ol>
    </nav>
  );
};
